
import breadcrumb from '../common/breadcrumb.vue';
    export default {
  components: { breadcrumb },
        name: "HappyKidsHeroSection",
        props: {
            anchorLink: {
                type: String,
                default: '#'
            },
            data: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                isActive: false,
                currentSlug: this.$route?.params?.productCat,
                productSubCatSlug: this.$route?.params?.productSubCat,
                windowWidth: 0
            }
        },
        computed: {
            backgroundSrc() {
                return {
                    backgroundImage: `url(${this.data?.backgroundImage?.url})`
                };
            },
            rightImageScr() {
                if (this.windowWidth > 768 && this.windowWidth < 1025) {
                    return this.data?.headImage2?.url;
                }
                return this.data?.headImage?.url;
            },
            headStyle() {
                if (this.$route.params.productCat === 'before-birth' ) {
                    return {marginBottom: "40px"}
                }
                return {}
            },
            subtitleBackgroundColor() {
                if (this.$route.params.productCat === 'young-kids') {
                    return {backgroundColor: "#FFBA4E"}
                }
                return {backgroundColor:"#FF7E7E"}
            },
            showSubcategory() {
                if (this.$route.params.any){
                    return this.$route.params.any.includes('before-birth') ? false : true;
                }
                if (this.$route.params.productCat !== 'before-birth') {
                    return true;
                }
                return false;
            },
            adjustPadding() {
                return this.$route.params.any.includes('before-birth')? {paddingBottom: '90px', paddingTop: '10px'} : {};
            }
        },
        mounted() {
            this.updateScreenWidth();
            this.onScreenResize();
        },
        methods: {
            clickToSelect(slug) {
                this.$router.push({path: this.localePath('/happy-kids/' + this.$route.params.year + slug + '/' + this.data?.defaultCoverage?.Slug)})
                this.isActive = !this.isActive;
            },
            iconSrc(icon) {
                return require(`@/assets/images/family/icon/${icon}.svg`)
            },
            onScreenResize() {
                window.addEventListener("resize", () => {
                this.updateScreenWidth();
            });
            },
            updateScreenWidth() {
                this.windowWidth = window.innerWidth;
            },
        },
    }

